import { createApiHook } from '../hooks';
import { audiencesApiFactory } from './audiencesApiFactory';

export const useAudiencesApi = createApiHook(audiencesApiFactory);
